unit Unit3;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WebLib.REST,
  WebAudio
  ;

type
  TForm3 = class(TForm)
    WebButton1: TButton;
    lbox1: TListBox;
    Memo1: TMemo;
    procedure WebButton1Click(Sender: TObject);

  private
    [async] procedure Player_test; async;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form3: TForm3;

implementation

{$R *.dfm}

//==============================================================
procedure TForm3.WebButton1Click(Sender: TObject);
//==============================================================
begin
  Player_test;
end;

// create two methods:
//   PlayURL( const aURL : string )
//   PlayStream( aStrm : TStream )

//==============================================================
procedure TForm3.Player_test;
//==============================================================
var
  AContext:  TJSAudioContext;
  AGainNode: TJSGainNode;
  ABufferSourceNode: TJSAudioBufferSourceNode;

  ARequest: THTTPRequest;
  AResponse : TJSXMLHTTPRequest;

  ms : TMemoryStream;
  s : string;
  n : integer;

begin
  AContext := TJSAudioContext.New;
  AGainNode := AContext.CreateGain;
  ABufferSourceNode := AContext.CreateBufferSource;
  ABufferSourceNode.Connect( AContext.Destination );
(*
  ms := TMemoryStream.Create;
  ms.LoadFromURL(lbox1.Items[0], false);

  memo1.Lines.Add( Format( 'Loaded into stream; Length=%d', [ms.Position] ) );
  ms.Position := 0;

*)
  ARequest := THTTPRequest.Create(Self);
  //ARequest.Headers.Add( 'Access-Control-Allow-Origin=*' );


  n := lbox1.ItemIndex;
  if (n < 0) then Exit;

  ARequest.URL := lbox1.Items[n];
//  ARequest.URL := 'https://www.dropbox.com/s/4mn8ihrhbkl0gux/snippet1.mp3?dl=1';
  ARequest.ResponseType := rtArrayBuffer;

  try
    AResponse := await( TJSXMLHTTPRequest,
                        ARequest.Perform() );

    ABufferSourceNode.Buffer := await( TJSAudioBuffer,
                                AContext.DecodeAudioData(TJSArrayBuffer(AResponse.Response)));
    ABufferSourceNode.Start;

  except
    on E: Exception do
    begin
      // file not found, etc.
      ShowMessage(E.ClassName+': '+E.Message);
    end;
  end;

end;

procedure TForm3.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebButton1 := TButton.Create(Self);
  lbox1 := TListBox.Create(Self);
  Memo1 := TMemo.Create(Self);

  WebButton1.BeforeLoadDFMValues;
  lbox1.BeforeLoadDFMValues;
  Memo1.BeforeLoadDFMValues;
  try
    Name := 'Form3';
    Width := 640;
    Height := 480;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -16;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebButton1.SetParentComponent(Self);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 248;
    WebButton1.Top := 228;
    WebButton1.Width := 113;
    WebButton1.Height := 49;
    WebButton1.Caption := 'Play';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    lbox1.SetParentComponent(Self);
    lbox1.Name := 'lbox1';
    lbox1.Left := 52;
    lbox1.Top := 20;
    lbox1.Width := 501;
    lbox1.Height := 161;
    lbox1.HeightPercent := 100.000000000000000000;
    lbox1.ItemHeight := 19;
    lbox1.WidthPercent := 100.000000000000000000;
    lbox1.Items.BeginUpdate;
    try
      lbox1.Items.Clear;
      lbox1.Items.Add('http://tayshn.com/vSTtRVaQ3L3bzarx/sample-3s.mp3');
      lbox1.Items.Add('https://tayshn.com/vSTtRVaQ3L3bzarx/sample-3s.mp3');
    finally
      lbox1.Items.EndUpdate;
    end;
    lbox1.ItemIndex := -1;
    Memo1.SetParentComponent(Self);
    Memo1.Name := 'Memo1';
    Memo1.Left := 52;
    Memo1.Top := 304;
    Memo1.Width := 501;
    Memo1.Height := 141;
    Memo1.AutoSize := False;
    Memo1.HeightPercent := 100.000000000000000000;
    Memo1.SelLength := 0;
    Memo1.SelStart := 0;
    Memo1.WidthPercent := 100.000000000000000000;
  finally
    WebButton1.AfterLoadDFMValues;
    lbox1.AfterLoadDFMValues;
    Memo1.AfterLoadDFMValues;
  end;
end;

end.